import {measure} from "./promise-fastdom";

const _ = new WeakMap();
const pendingOffs = [];

/**
 * @constructor
 * @param {MediaQueryList} query
 * @param {Mode} mode
 */
export default function BreakpointMode(query, mode) {
    const o = _.set(this, {
        query: query,
        mode: mode,
    }).get(this);

    o.handler = query => {
        // off before on
        query.matches ? setTimeout(() => this.on(), 0) : this.off();
    };

    query.addEventListener('change', o.handler);
    query.matches && this.on();
}

BreakpointMode.prototype.on = function () {
    const o = _.get(this);
    return Promise.all(pendingOffs).then(o.mode.on.bind(o.mode));
}

BreakpointMode.prototype.off = function () {
    const o = _.get(this);
    const p = o.mode.off();

    pendingOffs.push(p);
    return p.then(() => pendingOffs.splice(pendingOffs.indexOf(p), 1));
}

BreakpointMode.prototype.destroy = function () {
    const o = _.get(this);
    o.query.removeEventListener('change', o.handler);
    _.delete(this);
}

BreakpointMode.namedBreakpoint = function (breakpoint) {
    return Promise.resolve().then(measure(() => {
        return window.getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${breakpoint}`);
    }));
}

BreakpointMode.maxWidthQuery = function (width) {
    return `(max-width:${parseFloat(width) - (1 / 16)}em)`;
}